const initState = {
    loading: false,
    message: {},
}

const fileUploadSReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_LOADING_UPLOAD_S':
            return {
                ...state,
                loading: true,
                message: {},
            }
        case 'SET_MESSAGE_UPLOAD_S':
            return {
                ...state,
                loading: false,
                message: action.payload,
            }
        default:
            return state
    }
}

export default fileUploadSReducer;